export default "__VITE_ASSET__DuGuVN4g__"